import React, { Fragment, useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import getVideoId from 'get-video-id';


function Video() {
  const [copied, setCopied] = React.useState(false); 
  const [on, setOnState] = React.useState(false);
  const [checkAddButton, setCheckAddButton] = React.useState(false);
  const [isTrueVal, setIsTrueVal] = React.useState(false);
  const [inputFieldsJp1, setInputFieldsJp1] = useState({
      name: ''
  }) 
  const [inputFieldsJp, setInputFieldsJp] = useState(['']) 
  const [youTubeData, setYouTubeData] = useState([]) 

   
  const handleChange5 = (evnt) => {
    const { name, value } = evnt.target;    
    if(name=== 'name'){
      setCheckAddButton(false);
    } 
    setInputFieldsJp1((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    }) 
  }
   
  function MyButton(props) {
    return <button {...props} />
  }
   
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, [])
  const getURLDATA = async (id) =>{
    await fetch(`https://www.googleapis.com/youtube/v3/videos?part=snippet&id=`+id+`&fields=items&part=contentDetails&key=AIzaSyC_05QIAOCgQUN45nCF5jN2bdwqqVTUJ3I`)
    .then(response => {
      return response.json()
    })
    .then(data => { 
      const dataU = data.items;  
      if(dataU.length > 0){
        const dataArr = [{
          'name': dataU[0].snippet.title,
          'description': dataU[0].snippet.localized.description,
          'thumbnails': dataU[0].snippet.thumbnails.default.url,
          'duration': dataU[0].contentDetails.duration,
          'id': dataU[0].id,
          "contentUrl": `"https://www.youtube.com/watch?v=`+dataU[0].id+`"`,
          "embedUrl": `"https://www.youtube.com/embed/`+dataU[0].id+`"`,
          "target": `"https://youtu.be/`+dataU[0].id+`?t={seek_to_second_number}"`,
          'publishedAt': callDateFormate(new Date(dataU[0].snippet.publishedAt))
        }];
        const numbersCombined = [...youTubeData, ...dataArr];
        setYouTubeData(numbersCombined) 
      }
    })
  }
  const handleClickButton = () =>{
    if(on === false){
      setCheckAddButton(false);
      const urldata = inputFieldsJp1.name;  
      setInputFieldsJp1({name:''})
      const { id } = getVideoId(urldata);
      let url_id = id; 
      if(id=== null){
        url_id = urldata;
      }else{
        url_id = id;
      }
      getURLDATA(url_id);
    }else{
      if(inputFieldsJp1.name1 && inputFieldsJp1.thumbnails){
        setCheckAddButton(false);
        const dataArr = [{
          'name': inputFieldsJp1.name1,
          'description': inputFieldsJp1.description,
          'thumbnails': inputFieldsJp1.thumbnails,
          'duration': "PT"+inputFieldsJp1.minuts+"M"+inputFieldsJp1.seconds+"S",
          'id': 0,
          "contentUrl": `"`+inputFieldsJp1.contentUrl+`"`,
          "embedUrl": `"`+inputFieldsJp1.embedUrl+`"`,
          "target": `"`+inputFieldsJp1.target+`?t={seek_to_second_number}"`,
          'publishedAt': inputFieldsJp1.publishedAt
        }];
        const numbersCombined = [...youTubeData, ...dataArr];
        setYouTubeData(numbersCombined) 
        setInputFieldsJp1({name1:'',title:'',description:'',thumbnails:'',minuts:'',seconds:'',publishedAt:'',contentUrl:'',embedUrl:'', target:''})
      }
      else{
        setCheckAddButton(true);
      }
    }
  }

  const toggle = () => setOnState(o => !o);    
 
  function callDateFormate(d){
    const dformat = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(d);
      return dformat;
  }
  
  const itemList = (youTubeData.length > 0)?
      youTubeData.map((items, index) => 
  `{
    "@type": "ListItem",
    "position": `+index+`,
    "item": {
      "@type": "VideoObject",
      "name": "`+items.name+`",
      "description": "`+items.description+`",
      "thumbnailUrl": "`+items.thumbnails+`",
      "duration": "`+items.duration+`",
      "contentUrl": `+items.contentUrl+`,
      "embedUrl": `+items.embedUrl+`,
      "uploadDate": "`+items.publishedAt+`",
      "potentialAction": {
        "@type": "SeekToAction",
        "target": `+items.target+`,
        "startOffset-input": "required name=seek_to_second_number"
      }
    }
  }`):``; 
  const videoScript = `<!-- START - Generated by https://w3speedup.com/tools/schema-markup-generator/ -->
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": [`+itemList+`]
    }
    </script>
    <!-- END - Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`;
   
    const resetFun = () =>{ 
      setInputFieldsJp1({name:'',name1:'', title:'',description:'',thumbnails:'',minuts:'',seconds:'',publishedAt:'',contentUrl:'',embedUrl:'', target:''});
    } 
    return (
        <div className='row mt-5 video_row'>
          <div className='col-md-8 mb-5 border ps-0'>
           <div className='mt-2 mb-2 article_row'> <i className="fa-solid fa-video me-3"></i> <b>Video</b> </div>
           <div className="row input_fields d-flex mt-4">
              <div className='col-md-12'>
                <div className="form-group me-2 mb-2 mt-4 add_video_button"> 
                  <button className={on? 'on newClass' : 'off newClass'}  onClick={toggle}>
                    <span className="pin" />
                  </button> 
                  <label> Add A Video</label>
                </div>
              </div>
              {(on=== false) &&
                <Fragment>
                <div className="col-6 pe-0">
                  <div className="form-group me-2 mb-2">
                    <label>YouTube Video URL or ID</label>
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.name} name="name" className="form-control"/>
                  </div>
                </div>
                <div className="col-6 ps-0">
                  <div className="form-group me-2 mb-2"> 
                    <label></label>
                    <button onClick={(evnt) => handleClickButton(evnt)} className={'form-control btn-success'} ><i className="fa fa-plus"></i> Add A YouTube Video</button>
                  </div>
                </div>
                </Fragment>
              }
              {on &&
                <div className='col-md-12'>  
                  <div className="row input_fields d-flex mt-4">
                    <div className="col-6">
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.name1} name="name1" className="form-control" placeholder='Name'/>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.description} name="description" className="form-control" placeholder="Video description" />
                      </div>
                        {isTrueVal && (
                          <div style={{ color: "#F61C04" }}>URL is not valid.</div>
                        )}
                    </div>
                    <div className="col-6">
                      <div className="form-group me-2 mb-2">
                        <input type="date" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.publishedAt} name="publishedAt" className="form-control" placeholder="uploadDate" />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group me-2 mb-2">
                        <input type="number" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.minuts} name="minuts" className="form-control" placeholder="minuts" />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group me-2 mb-2">
                        <input type="number" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.seconds} name="seconds" className="form-control" placeholder="seconds" />
                      </div>
                    </div>                          
                    <div className="col-6">
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.thumbnails} name="thumbnails" className="form-control" placeholder="ThumbnailUrl URL" />
                      </div>
                    </div>                         
                  </div>
                  <div className="row input_fields d-flex">
                    <div className="col-6">
                      <div className="form-group me-2 mb-2">
                        <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.contentUrl} name="contentUrl" className="form-control" placeholder="Content Url" />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group me-2 mb-2">
                        <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.embedUrl} name="embedUrl" className="form-control" placeholder="Embed Url" />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group me-2 mb-2">
                        <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp1.target} name="target" className="form-control" placeholder="Target Url" />
                      </div>
                    </div>                          
                    <div className="col-6 ps-0">
                      <div className="form-group me-2 mb-2"> 
                        <label></label>
                        <button onClick={(evnt) => handleClickButton(evnt)} className={'form-control btn-success'} ><i className="fa fa-plus"></i> Add A YouTube Video</button>
                      </div>
                    </div>
                  </div> 
                </div>
              }
              <div className='col-md-12'>
                <div className="card youtube_duration_card mt-5"> 
                    <ul>
                      {youTubeData && youTubeData.map((item, index)=>{
                        const firstChar = (item.duration).substring(2, ((item.duration).length)-1);
                        const duration = (firstChar).split("M");                         
                        let minuts = 0;
                        let seconds = 0;
                        if(duration[1] !==undefined){
                          minuts = duration[0];
                        }
                        if(duration[1] === undefined && duration[0]){
                          seconds = duration[0]
                        }else{
                          seconds = duration[1];
                        } 

                        return (
                          <li key={index}>
                            <div className="row">
                              <div className="col-md-3 youtube_duration_box-1">
                                <a href={`https://www.youtube.com/watch?v=`+item.id} target="_blank" rel="noreferrer">
                                  <img className="youtube_img_height" src={item.thumbnails} alt="youtube" />
                                  <span className="youtube_duration_class">{minuts}:{seconds}</span>
                                </a>
                              </div>
                              <div className="col-md-9 youtube_duration_box-2">
                                <h6 className='youtube_title_class'>{item.title}</h6>
                                <span className='youtube_desc_class'>{(item.description).substring(0,100)}{((item.description).length > 100) ?'...':''}</span>
                              </div>
                            </div>
                          </li>
                        )
                      })
                      }
                      
                    </ul>
                </div>
              </div>
            </div>            
          </div>          
          <div className='col-md-4'>
           <div className="card">
             <div className="card-header d-flex">
               <CopyToClipboard onCopy={onCopy} text={videoScript} >
                 <MyButton className="btn btn-success"><i className="fa-solid fa-copy"></i> Copy</MyButton>
               </CopyToClipboard>                
                 <MyButton className="btn btn-success" onClick={()=>resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i> Reset</MyButton> 
             </div>
             <div className="card-body">
               {videoScript}
             </div>
             {copied && 
               <div className="card-footer text-muted">
                 <div className="p-2 btn-success rounded">✅ copied successfully</div>
               </div>
             }
           </div>
          </div>
        </div>
  );
}

export default Video